import { useRef, useEffect, useState } from 'react'
import { formatAbbreviatedNumber } from '../../utils/numberUtils'

interface Props {
    label: string
    value: number
    compact?: boolean
}

export default function HelixSearchInsightItem({
    label,
    value,
    compact = false,
}: Props) {
    const [flash, setFlash] = useState(false)
    const flashTimeoutRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        setFlash(true)

        if (flashTimeoutRef.current) {
            clearTimeout(flashTimeoutRef.current)
        }

        flashTimeoutRef.current = setTimeout(() => {
            setFlash(false)
            flashTimeoutRef.current = null
        }, 300)
    }, [value])

    return (
        <div
            className={`${
                compact
                    ? 'flex-1 min-w-0'
                    : 'flex-1 min-w-[150px] max-w-[220px] h-28'
            } flex flex-col items-center justify-between border rounded-xl p-3 bg-white shadow text-center transition duration-300 hover:shadow-md overflow-hidden`}
        >
            <div
                className={`${
                    compact ? 'text-sm' : 'text-base'
                } text-gray-500 font-semibold truncate mb-2 px-2 leading-snug break-words whitespace-normal`}
            >
                {label}
            </div>
            <div
                className={`${
                    compact ? 'text-lg' : 'text-2xl'
                } font-mono font-bold transition-colors duration-300 ${
                    flash
                        ? 'text-transparent bg-clip-text bg-gradient-to-r from-[#33A86F] via-[#4FCF93] to-[#8BE6B3]'
                        : 'text-transparent bg-clip-text bg-gradient-to-r from-ctxt-blue-dark via-ctxt-blue to-sky-500'
                }`}
            >
                {formatAbbreviatedNumber(value)}
            </div>
        </div>
    )
}
